export const showBuildPlateCheckSelector = state => state.appState.modalsState.showBuildPlateCheck;
export const settingsInputErrorSelector = state => state.appState.modalsState.settingsInputError;
export const isUploadingFolderContainsMakerbotSelector = state => state.appState.modalsState.showFolderContainsMakerbot;
export const detectedMakerbotFilesSelector = state => state.appState.modalsState.detectedMakerbotFiles
export const showBlockedRedirectAlertSelector = state => state.appState.modalsState.showBlockedRedirectAlert
